import * as React from "react";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";
import { TaskRequestStatus } from "../../../Wrap/Constants/Enums/Tasks/TaskRequestStatus";
import { ReportInfo } from "../../../Wrap/Models/Models/Reports/ReportInfo";
import { DocumentTaskRequestModel } from "../../../Wrap/Models/Models/Tasks/DocumentTaskRequestModel";
import { DocumentFileAction } from "../../Dashboard/Components/Clients/PortfolioDashboard/Components/Document/Action/DocumentFileAction";
import { DownloadButtonAction } from "./Actions/DownloadButtonAction";

export interface IDownloadButtonProps {
    request: DocumentTaskRequestModel;
    selectedAccount: string;
    callBack?: (val) => void;
    title?: string;
}
export interface IDownloadButtonState {
    isPending?: boolean;
    isCompleted?: boolean;
    reportInfo?: ReportInfo;
    url?: string;
    isFailed?: boolean;
}
export class DownloadButton extends BaseComponent<IDownloadButtonProps, IDownloadButtonState> {
    constructor(props: any) {
        super(props);
        this.state = { isPending: false, isCompleted: false, isFailed: false};
    }

    componentDidMount() {
        this.handleButtonClick();
    }

    private handleButtonClick = () => {
        this.setState({ isPending: true, isCompleted: false, isFailed: false });
        DownloadButtonAction.addTaskRequestForDocument(this.props.request, (data) => {
            this.setState({ reportInfo: data, isPending: true, isCompleted: false, isFailed: false });
            DownloadButtonAction.getTaskRequestStatus(data.TaskRequestID.toString(), (callback) =>
                this.onStatusChange(callback.Status)
            );
        });
    };

    private onStatusChange(status: TaskRequestStatus) {
        if (
            status == TaskRequestStatus.Pending ||
            status == TaskRequestStatus.Running ||
            status == TaskRequestStatus.Allocated ||
            status == TaskRequestStatus.PendingDelayed ||
            status == TaskRequestStatus.PendingHold
        ) {
            setTimeout(() => {
                DownloadButtonAction.getTaskRequestStatus(this.state.reportInfo.TaskRequestID.toString(), (callback) =>
                    this.onStatusChange(callback.Status)
                );
            }, 2000);
        } else if (status == TaskRequestStatus.Complete) {
            if (this.props.callBack) {this.props.callBack(this.state.reportInfo);}
            const hierarchyId = this.props.selectedAccount == null ? "" : this.props.selectedAccount;
            DocumentFileAction.get(
                hierarchyId,
                this.state.reportInfo.FileName,
                true,
                0,
                this.state.reportInfo.TaskRequestID,
                null,
                (result: string) => {
                    this.setState({
                        isPending: false,
                        isCompleted: true,
                        isFailed: false,
                        url: result,
                    });
                }
            );
        } else {
            if (this.props.callBack) this.props.callBack(this.state.reportInfo);
            let hierarchyId = this.props.selectedAccount == null ? "" : this.props.selectedAccount;
            DocumentFileAction.get(
                hierarchyId,
                this.state.reportInfo.FileName,
                true,
                0,
                this.state.reportInfo.TaskRequestID,
                null,
                (result: string) => {
                    this.setState({
                        isPending: false,
                        isCompleted: false,
                        isFailed: true,
                        url: result,
                    });
                }
            );
        }
    }

    public render(): JSX.Element {
        return (
            <>
                {!this.state.isCompleted && this.props.title && <span>{this.props.title}</span>}
                {this.state.isCompleted && this.props.title &&
                    <a
                        target={"_blank"}
                        href={this.state.url}
                    >
                        {this.props.title}
                    </a>
                }
                {this.state.reportInfo?.TaskRequestID.toString() && <span className="ml-2">({this.state.reportInfo.TaskRequestID.toString()})</span>}
                {!this.state.isPending && this.state.isFailed && (
                    <span className="text-negative mr-24" style={{ whiteSpace: 'nowrap' }}> Failed or Cancelled</span>
                )}
                {this.state.isPending && <div className="lds-dual-ring"></div>}
                {this.state.isCompleted && (
                    <>
                        <a
                            target={"_blank"}
                            href={this.state.url}
                        >
                        <button
                        type="button"
                        className="download-button label-sr-only ml-20"
                    >
                        <span className="icon" aria-hidden="true"></span>
                        <span className="sr-only"> Download</span>
                    </button>
                    </a>
                    </>
                )}
            </>
        );
    }
}
